import { Injectable } from '@angular/core';
// Import the buildUrl function (usually the default export)
import buildUrl from 'build-url-ts';

// We can import the *exported* helper types if needed for constructing options
import { IQueryParams, IDisableCsvType } from 'build-url-ts';

// Define a type locally based on the library's structure since IUrlOptions isn't exported
// This improves clarity in our service signature but requires manual syncing
// if the library changes significantly.
// Alternatively, you could use 'any' or 'object' for the options type,
// relying solely on TypeScript inference during the actual buildUrl call.
type UrlOptions = {
  path?: string | number;
  lowerCase?: boolean;
  queryParams?: IQueryParams; // Use the imported type here
  disableCSV?: boolean | IDisableCsvType; // Use the imported type here
  hash?: string | number;
};


@Injectable({
  providedIn: 'root'
})
export class UrlBuilderService {

  constructor() { }

  /**
   * Builds a URL using the build-url-ts library.
   * NOTE: The library doesn't export its internal 'IUrlOptions' interface,
   * so we use a locally defined 'UrlOptions' type or rely on TS inference.
   * Refer to the build-url-ts documentation/definitions for valid options properties.
   *
   * @param baseUrlOrOptions - The base URL (string | null) or an options object if no base URL is needed.
   * @param options - Optional configuration for path, query parameters, hash, etc.
   *                  Only used if the first argument is a string/null (baseUrl).
   * @returns The constructed URL string.
   */
  build(baseUrlOrOptions?: string | null | UrlOptions, options?: UrlOptions): string | null {
    // The library's function handles the overloaded signature.
    // TypeScript will infer and check the types when we call the actual function.
    // We cast the result to `string | null` as the library definition says `string`,
    // but inspecting the source or testing might reveal null is possible in edge cases.
    // The library definition file indicates it returns 'string', but returning null seems
    // plausible if no base or path is given. Let's stick to the definition's `string`.
    // If you find it can return null, adjust the return type here.
    return buildUrl(baseUrlOrOptions, options);
  }

  // Optional: You can still add helper methods as before
  /*
  buildApiUrl(path: string, queryParams?: IQueryParams): string { // Use IQueryParams here
    const baseApi = 'https://api.yourapp.com/v1';
    return this.build(baseApi, { // TS will check this object structure against buildUrl's needs
      path: path,
      queryParams: queryParams
    });
  }
  */
}